import React from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { Box, Text, CardRow, CardDetails } from '@/presentation/components'
import { serviceOrderDetailState, selectedOsImageViewState } from '@/presentation/pages/ServiceOrderDetail/components'
import { styles } from '../../styles'

export const OsSignatures: React.FC = () => {
  const serviceOrderDetails = useRecoilValue(serviceOrderDetailState)
  const setImageView = useSetRecoilState(selectedOsImageViewState)

  return (
    <div style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
      {!!serviceOrderDetails.assinaturasFechamento?.length &&
        <>
          <Text style={styles.pageInfo}>Assinaturas</Text>
          <CardRow>
            {serviceOrderDetails.assinaturasFechamento.map((sign, index) => (
              <TouchableOpacity key={index} onPress={() => { setImageView({ uri: sign.caminhoArquivo, description: sign.nomeArquivo }) }}>
                <CardDetails>
                  <img src={sign.caminhoArquivo} style={{ maxWidth: 280, maxHeight: 280 }} />
                  <Box style={styles.additionalTextBox}>
                    <Text style={styles.additionalText}>{sign.nomeArquivo}</Text>
                  </Box>
                </CardDetails>
              </TouchableOpacity>
            ))}
          </CardRow>
        </>
      }
    </div>
  )
}
